module.exports = __webpack_public_path__ + "img/olsera.2485a292.png";